import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields";
import { Modes } from "../../common/fields/mode";

export const equipmentType: FieldSchema = {
  name: "equipmentType",
  grid: {
    displayed: true,
    order: 80,
  },
  data: {
    variant: DataVariants.ENUM,
    options: ["C", "D", "E", "I", "L", "M", "P", "Q", "S", "T", "Y"],
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Equipment type",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
  